/*
Makes an AJAX call to fetch the killswitch list in account-xapi
If user passes in a killswitch list, that is returned.

@returns a resolved Promise with the response from xApi if call was successful
@returns a rejected Promise if call failed
*/
const getDksKillswitches = killswitchList => new Promise((resolve, reject) => {
  if (killswitchList) {
    resolve(killswitchList);
  } else {
    fetch('/account-xapi/api/dksswitches', {
      method: 'GET',
    }).then((response) => {
      if (response.ok) {
        return response.json();
      }
      const errorText = response.statusText || 'Error';
      throw new Error(errorText);
    }).then(data => resolve(data)).catch((error) => {
      console.error(':: xAPI call to fetch KillSwitches failed: ', error);
      reject(error);
    });
  }
});
/*
Checks the value of a killswitchName passed in
Gets killswitch list by calling getDksKillswitches
If user passes a killswitchList, getDksKillswitches() function
will check against that, and not make another xAPI call

@return boolean true/false indicating if KS is ON/OFF
*/
const dksCheck = async (killswitchName, killswitchList) => {
  let ret = false;
  try {
    const killswitches = await getDksKillswitches(killswitchList);
    if (killswitches.KillSwitches[killswitchName]) {
      if (typeof killswitches.KillSwitches[killswitchName] === 'string') {
        if (killswitches.KillSwitches[killswitchName] === 'true') {
          ret = true;
        } else {
          ret = false;
        }
      } else {
        ret = killswitches.KillSwitches[killswitchName];
      }
    } else {
      ret = false;
    }
  } catch (e) {
    ret = false;
  }

  return ret;
};

export {
  getDksKillswitches,
  dksCheck,
};
